import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DatePicker from "react-datepicker";
import moment from "moment";
import autoSuggestJSON from '../../assets/json/autosuggest.json';

import HeadingBox from '../../components/UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../components/UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../components/UI/Headings/HeadingH3/HeadingH3';

import DividerIcon from '../../components/BookingEngine/DividerIcon/DividerIcon';

import crossImage from '../../assets/images/engine-clear.svg';
import exchangeImage from '../../assets/images/engine-exchange.svg';
import searchImage from '../../assets/images/search.svg';


import BookingEngineSelect from '../../components/BookingEngine/BookingEngineSelect/BookingEngineSelect';
import Button from '../../components/UI/Button/Button';
import Tooltip from '../../components/UI/Tooltip/Tootip';

// import Travellers from "../../components/Travellers/Travellers";
import Travellers from '../../components/Travellers/FlightTravellers/FlightTravellers';
import AutoSuggestBox from "../../components/UI/AutoSuggestBox/AutoSuggestBox";

import classes from "./FlightBookingEngine.scss";
import MobileCloseBookingEngineButton from '../../components/UI/Mobile/MobileCloseBookingEngineButton/MobileCloseBookingEngineButton';

import {
  hideSideNavigation, 
  hideTabletBookingEngine, 
  hideMobileBookingEngine, 
  hideReturnFlights, 
  setOriginCity, 
  setDestinationCity, 
  searchOriginCity, 
  searchDestinationCity, 
  setOriginValidation, 
  setDestinationValidation, 
  switchCity, 
  resetSearch,
  resetFilters,
  resetFarePrice,
  resetAddons,
  setStartDate,
  setEndDate,
  clearEndDate,
  resetPollingCounter,
  resetStackFlight
  } from '../../store/actions/index';

import InputMaterial from '../../components/UI/InputMaterial/InputMaterial';

import BookingEngineContainer from '../../components/BookingEngine/BookingEngineContainer/BookingEngineContainer';
import BookingEngineInputContainer from '../../components/BookingEngine/BookingEngineInputContainer/BookingEngineInputContainer';

import Media from 'react-media';

class BookingEngine extends Component {
  bookingEngineClasses = [];

  state = {
    airportsData: "",
    selectedIndex: 0,
    isTravellerVisible: true,
    flightClass: 'Economy',
    flightClassText: 'Economy',
    isFlightClassMenuOpen: false
  };

  // Date Functions Start

  handleChange = date => {
    let startDate = date;
    this.props.onSetStartDate(startDate);
  };

  handleChange = ({ startDate, endDate }) => {
    startDate = startDate || this.props.startDate;
    endDate = endDate || this.props.endDate;

    if (startDate.isAfter(endDate)) {
      endDate = startDate;
    }
    this.props.onSetEndDate(startDate, endDate);
  };

  handleChangeStart = startDate => this.handleChange({ startDate });

  handleChangeEnd = endDate => this.handleChange({ endDate });

  onHideTraveller = () => {
    this.setState({
      isTravellerVisible: false
    })
  }

  onShowTraveller = () => {
    this.setState({
      isTravellerVisible: true
    })
  }

  // Date Functions End

  // Search Airport Start

  searchAirportHandler = (event, id, focus) => {
    if(focus==="focus") {
      event.target.select();
    }
    if (event.target.value || event.target.value.length >= 0) {
      this.getAirports(event.target.value, id);
      if (id === 1) {
        this.props.onSearchOriginCity(event.target.value);
      } else if (id === 2) {
        this.props.onSearchDestinationCity(event.target.value);
      }
    }
  };

  getAirports = (value, id) => {
    let response = autoSuggestJSON;
    if (response.airports.length === 0) {
      this.setState({
        airportsData: ''
      })
    } else {
      if(id === 1) {
        const index = response.airports.findIndex(airport => {
          return airport.flight[0].ac === this.props.destinationCity
        });
        if(index >= 0) {
          response.airports.splice(index, 1);
        }
      }
      if(id === 2) {
        const index = response.airports.findIndex(airport => {
          return airport.flight[0].ac === this.props.originCity
        });
        if(index >= 0) {
          response.airports.splice(index, 1);
        }
      }
      this.setState({
        airportsData: response
      })
    }
  };

  // Search Airport End

  hoverInHandler = index => {
    this.setState({
      selectedIndex: index
    });
  };

  hoverOutHandler = index => {
    this.setState({
      selectedIndex: index
    });
  };

  autoSuggestKeyHandler = event => {
    event.preventDefault();
    if (event.keyCode === 38) {
      if (this.state.airportsData) {
        if (this.state.selectedIndex > 0) {
          this.setState(prevState => {
            return { selectedIndex: prevState.selectedIndex - 1 };
          });
        }
        if (this.state.selectedIndex === 0) {
          this.setState(prevState => {
            return { selectedIndex: prevState.airportsData.airports.length - 1 };
          });
        }
      }
    } else if (event.keyCode === 40) {
      if (this.state.airportsData) {
        if ( this.state.selectedIndex >= this.state.airportsData.airports.length - 1 ) {
          this.setState({
            selectedIndex: 0
          });
        }
        if ( this.state.selectedIndex < this.state.airportsData.airports.length - 1 ) {
          this.setState( (prevState) => {
              return { selectedIndex: prevState.selectedIndex + 1 };
            });
        }
      }
    } else if (event.keyCode === 13 || event.keyCode === 9) {
      if (this.state.airportsData) {
        const selectedAirport = this.state.airportsData.airports[this.state.selectedIndex];
        const cityCode = selectedAirport.flight[0].ac;
        const countryCode = selectedAirport.flight[0].cc;
        const city = selectedAirport.flight[0].ct;

        if (this.props.inputType === 1) {
          this.props.onSetOriginCity(city, cityCode, countryCode);
        } else if (this.props.inputType === 2) {
          this.props.onSetDestinationCity(city, cityCode, countryCode);
        }
      }
    }
  };

  searchFlightHandler = () => {
    if(this.props.location.pathname.includes('/flights/search')) {
      this.props.onResetFilters();
    }
    this.props.onResetPollingCounter();
    this.props.onResetStackFlight();
    this.props.onResetSearch();
    this.props.onResetFarePrice();
    this.props.onResetAddons();
    this.props.onHideReturnFlights();
    if(this.props.origin.trim().length === 0) {
      this.props.onSetOriginValidation();
      return;
    }
    if(this.props.destination.trim().length === 0 && this.props.originValid) {
      this.props.onSetDestinationValidation();
      return;
    }
    this.props.onHideMobileBookingEngine();
    if(window.innerWidth > 600 && window.innerWidth <= 900) {
      this.props.onHideTabletBookingEngine();
    }
    this.props.onHideSideNavigation();
    const queryParams = [];
    queryParams.push("ADT=" + this.props.adult);
    queryParams.push("CHD=" + this.props.child);
    queryParams.push("INF=" + this.props.infant);
    queryParams.push("class=" + this.state.flightClass);
    queryParams.push("destination=" + this.props.destinationCity);
    queryParams.push("destinationCountry=" + this.props.destinationCountry);
    queryParams.push("flexi=" + 0);
    queryParams.push("origin=" + this.props.originCity);
    queryParams.push("originCountry=" + this.props.originCountry);
    queryParams.push("source=fresco-home");
    queryParams.push("version=" + 1.1);
    queryParams.push("viewName=normal");
    queryParams.push("noOfSegments=" + 1);

    if (this.props.startDate && !this.props.endDate) {
      queryParams.push("type=O");
      queryParams.push("flight_depart_date=" + this.props.startDate.format("DD/MM/YYYY"));
      const queryString = queryParams.join("&");
      this.props.history.push({
        pathname: "/flights/search",
        search: "?" + queryString,
      });
    } else if (this.props.startDate && this.props.endDate) {
      queryParams.push("type=R");
      queryParams.push("flight_depart_date=" + this.props.startDate.format("DD/MM/YYYY"));
      queryParams.push("arrivalDate=" + this.props.endDate.format("DD/MM/YYYY"));
      const queryString = queryParams.join("&");
      this.props.history.push({
        pathname: "/flights/search",
        search: "?" + queryString,
      });
    }
  };

  onFocusOutHandler = () => {
    if (this.state.airportsData) {
      const selectedAirport = this.state.airportsData.airports[this.state.selectedIndex];
      const cityCode = selectedAirport.flight[0].ac;
      const countryCode = selectedAirport.flight[0].cc;
      const city = selectedAirport.flight[0].ct;
      if (this.props.inputType === 1) {
        if(countryCode === "IN" && this.props.destinationCountry === "IN") {
          this.selectFlightClass('Economy', 'Economy');
        }
        this.props.onSetOriginCity(city, cityCode, countryCode);
      } else if (this.props.inputType === 2) {
        if(countryCode === "IN" && this.props.originCountry === "IN") {
          this.selectFlightClass('Economy', 'Economy');
        }
        this.props.onSetDestinationCity(city, cityCode, countryCode);
      }
    }
  }

  selectFlightClass = (flightClassText, flightClass) => {
    this.setState({
        flightClassText: flightClassText,
        flightClass: flightClass,
        isFlightClassMenuOpen: false
    })
  }

  openFlightClassMenu = () => {
    this.setState({
        isFlightClassMenuOpen: true
    })
  }

  closeFlightClassMenu = () => {
    this.setState({
      isFlightClassMenuOpen: false
    })
  }

  render() {
    const border = '1px solid var(--color-border)';
    return (
            <React.Fragment>
              <BookingEngineContainer>
                <div className={this.props.location.pathname.trim('').includes('/flights/search') && window.innerWidth > 600 && window.innerWidth < 900 ? classes.UpperMiddleWrapper : null}>
                  <div className={`u-relative ${this.props.location.pathname.trim('').includes('/flights/search') && window.innerWidth > 600 && window.innerWidth < 900 ? classes.BoxOne : null}`}>
                    <div style={{
                        display: this.props.mobileBookingEngine ? 'none' : 'block',
                        marginBottom: '1.5rem'
                      }}>
                      <HeadingBox>
                        <div className="mb-1">
                          <HeadingH2 size={26} weight="Regular" color="Dark">Let's, Book a Flight!</HeadingH2>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">Find best flights around the world</HeadingH3>
                      </HeadingBox>
                    </div>
                    <div className={'u-relative u-flex f-row'}>
                      <div className={`${classes.ExchangeIcon} u-flex justify-content-center align-items-center u-transitionAll300Ease`}  
                      onClick={() => this.props.onSwitchCity()} style={{
                        cursor: 'pointer',
                        opacity: this.props.inputType === 1 || this.props.inputType === 2 ? '0' : '1',
                        visibility: this.props.inputType === 1 || this.props.inputType === 2 ? 'hidden' : 'visible'
                      }}>
                        <img src={exchangeImage} alt='Exchange'/>
                      </div>
                      <Tooltip showTooltip={this.props.originTooltip} type="validationFrom" aria-label="Add Origin" />
                        <BookingEngineInputContainer style={{
                            flex: this.props.inputType === 1 ? '1' : '0 0 50%',
                            display: this.props.inputType === 2 ? 'none' : 'flex'
                          }}>
                          <InputMaterial
                            type='text'
                            label='From'
                            alignment='left'
                            style={{borderBottom: !this.props.originValid ? '2px solid #ff7d7d' : `${border}`}}
                            value={this.props.origin}
                            onChange={event => this.searchAirportHandler(event, 1)}
                            onKeyUp={this.autoSuggestKeyHandler}
                            onFocus={event => this.searchAirportHandler(event, 1, "focus")}
                            onBlur={this.onFocusOutHandler}
                            />
                        </BookingEngineInputContainer>
                      <Tooltip showTooltip={this.props.destinationTooltip} type="validationTo" aria-label="Add Destination" />
                      <BookingEngineInputContainer style={{
                          flex: this.props.inputType === 2 ? '1' : '0 0 50%',
                          display: this.props.inputType === 1 ? 'none' : 'flex'
                        }}>
                        <InputMaterial
                          type='text'
                          label='To'
                          alignment='right'
                          style={{borderBottom: !this.props.destinationValid ? '2px solid #ff7d7d': `${border}`}}
                          value={this.props.destination}
                          onChange={event => this.searchAirportHandler(event, 2)}
                          onKeyUp={this.autoSuggestKeyHandler}
                          onFocus={event => this.searchAirportHandler(event, 2, "focus")}
                          onBlur={this.onFocusOutHandler}
                          align={this.props.inputType === 2 ? 'true' : null}
                        />
                      </BookingEngineInputContainer>
                    </div>
                  <AutoSuggestBox
                    toggleAutoSuggest={this.props.autoSuggestBox}
                    airportData={this.state.airportsData}
                    selectCity={this.onFocusOutHandler}
                    type={this.props.inputType}
                    activeItem={this.state.selectedIndex}
                    hoverInHandler={this.hoverInHandler}
                    hoverOutHandler={this.hoverOutHandler}
                  />
                  <div
                    className={`u-relative`}
                    style={{ display: this.props.middleContainer ? "block" : "none" }}>
                    <div className={'u-relative u-flex f-row'}>
                      <DividerIcon/>
                      <BookingEngineInputContainer>
                        <DatePicker
                          minDate={moment()}
                          dateFormat="MMM DD, ddd"
                          selected={this.props.startDate}
                          selectsStart
                          startDate={this.props.startDate}
                          endDate={this.props.endDate}
                          onChange={this.handleChangeStart}
                          onFocus={this.onHideTraveller}
                          onBlur={this.onShowTraveller}
                          customInput={ <InputMaterial
                              type='text'
                              fieldtype="datepicker"
                              label='Depart Date'
                              alignment='left'
                            />
                          }
                        />
                      </BookingEngineInputContainer>
                      <BookingEngineInputContainer>
                      { this.props.endDate ? <div onClick={() => this.props.onClearEndDate()} className={classes.EngineClear}><img src={crossImage} alt='Clear'/></div> : null }
                        <DatePicker
                          minDate={moment()}
                          dateFormat="MMM DD, ddd"
                          selected={this.props.endDate}
                          selectsEnd
                          startDate={this.props.startDate}
                          endDate={this.props.endDate}
                          onChange={this.handleChangeEnd}
                          onFocus={this.onHideTraveller}
                          onBlur={this.onShowTraveller}
                          ref={(datepicker) => { this.datepicker = datepicker }}
                          customInput={ <InputMaterial
                              type='text'
                              fieldtype="datepicker"
                              label='Return Date'
                              alignment='right'
                            />
                          }
                        />
                      </BookingEngineInputContainer>
                    </div>
                  </div>
                  <div style={{ display: this.props.middleContainer ? "block" : "none" }}>
                    <BookingEngineSelect 
                        selectFlightClass={this.selectFlightClass} 
                        flightClassText={this.state.flightClassText} 
                        isFlightClassMenuOpen={this.state.isFlightClassMenuOpen} 
                        openFlightClassMenu={this.openFlightClassMenu} 
                        closeFlightClassMenu={this.closeFlightClassMenu}
                        originCountry={this.props.originCountry}
                        destinationCountry={this.props.destinationCountry}/>
                  </div>
                  </div>
                  <div
                    className={`u-relative ${this.props.location.pathname.trim('').includes('/flights/search') && window.innerWidth > 600 && window.innerWidth < 900 ? classes.BoxTwo : ''}`}
                    style={{ display: this.props.middleContainer ? "block" : "none" }}>
                    { 
                      this.state.isTravellerVisible ? 
                        <Travellers 
                          adult={this.props.adult}
                          child={this.props.child}
                          infant={this.props.infant} /> : null
                    } 
                  </div>
                </div>
                <div style={{marginBottom: (this.props.mobileBookingEngine && window.innerWidth <= 600) ? '0' : 'null', marginTop: this.props.mobileBookingEngine ? '1.5rem': '0', display: this.props.middleContainer ? "block" : "none"}} className={`${classes.ButtonWrapper} u-textAlignCenter`}>
                  <Media query="(max-width: 599px)">
                      {matches =>
                        matches ? <Button theme='Primary' width='Block' type='Search' onClick={this.searchFlightHandler}>Search</Button> : null}
                  </Media>
                  <Media query="(min-width: 600px) and (max-width: 900px)">
                        {matches =>
                          matches  && !(this.props.location.pathname.trim('').includes('/flights/search')) ? <Button theme='Primary' width='Block' type='Search' onClick={this.searchFlightHandler}>Search</Button> : null}
                  </Media>
                  <Media query="(min-width: 1200px)">
                        {matches =>
                          matches ? <Button theme='Primary' width='Block' type='Search' onClick={this.searchFlightHandler}>Search</Button> : null}
                  </Media>
                </div>
                <Media query="(max-width: 599px)">
                    {matches =>
                      matches && (this.props.location.pathname.trim('').includes('/flights/search')) ? <MobileCloseBookingEngineButton onClick={this.props.onHideMobileBookingEngine} style={{opacity: this.props.mobileBookingEngine ? 1 : null, visibility: this.props.mobileBookingEngine ? 'visible' : null}} /> : null}
                </Media>
                <Media query="(min-width: 599px) and (max-width: 900px)">
                      {matches =>
                        matches && (this.props.location.pathname.trim('').includes('/flights/search')) ? <button onClick={this.searchFlightHandler} className={classes.SearchBtn}><img src={searchImage} alt="Search" /></button> : null
                      }
                </Media>
              </BookingEngineContainer>
            </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    adult: state.travellers.adult,
    child: state.travellers.child,
    infant: state.travellers.infant,
    mobileBookingEngine: state.ui.mobileBookingEngine,
    origin: state.bookingEngine.origin,
    originCity: state.bookingEngine.originCity,
    originCountry: state.bookingEngine.originCountry,
    destination: state.bookingEngine.destination,
    destinationCity: state.bookingEngine.destinationCity,
    destinationCountry: state.bookingEngine.destinationCountry,
    originValid: state.bookingEngine.originValid,
    destinationValid: state.bookingEngine.destinationValid,
    originTooltip: state.bookingEngine.originTooltip,
    destinationTooltip: state.bookingEngine.destinationTooltip,
    middleContainer: state.bookingEngine.middleContainer,
    autoSuggestBox: state.bookingEngine.autoSuggestBox,
    inputType: state.bookingEngine.inputType,
    startDate: state.bookingEngine.startDate,
    endDate: state.bookingEngine.endDate
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHideSideNavigation: () => dispatch(hideSideNavigation()),
    onHideTabletBookingEngine: () => dispatch(hideTabletBookingEngine()),
    onHideMobileBookingEngine: () => dispatch(hideMobileBookingEngine()),
    onResetAddons: () => dispatch(resetAddons()),
    onHideReturnFlights: () => dispatch(hideReturnFlights()),
    onSetOriginCity: (city, cityCode, countryCode) => dispatch(setOriginCity(city, cityCode, countryCode)),
    onSetDestinationCity: (city, cityCode, countryCode) => dispatch(setDestinationCity(city, cityCode, countryCode)),
    onSearchOriginCity: (city) => dispatch(searchOriginCity(city)),
    onSearchDestinationCity: (city) => dispatch(searchDestinationCity(city)),
    onSetOriginValidation: () => dispatch(setOriginValidation()),
    onSetDestinationValidation: () => dispatch(setDestinationValidation()),
    onSwitchCity: () => dispatch(switchCity()),
    onResetSearch: () => dispatch(resetSearch()),
    onResetFilters: () => dispatch(resetFilters()),
    onResetFarePrice: () => dispatch(resetFarePrice()),
    onSetStartDate: (startDate) => dispatch(setStartDate(startDate)),
    onSetEndDate: (startDate, endDate) => dispatch(setEndDate(startDate, endDate)),
    onClearEndDate: () => dispatch(clearEndDate()),
    onResetPollingCounter: () => dispatch(resetPollingCounter()),
    onResetStackFlight: () => dispatch(resetStackFlight())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookingEngine));



// WEBPACK FOOTER //
// ./src/containers/FlightBookingEngine/FlightBookingEngine.js